export const user_role_display_name = {
    broker: "Broker",
    dataEntry: "CDT",
    dataAdmin: "Admin",
    portlandBrokerAdmin: "Portland Broker Admin",
    arizonaBrokerAdmin: "Arizona Broker Admin",
    accounting: "Accounting",
    propertyManagement: "Asset Services",
    evp: "RP",
    general: "General User",
    officeManager: "Office Manager",
    researchAdmin: "Research Admin",
    research: "Research",
    transition: "Transition Specialist",
    anonymous: "Anonymous",
    debtEquity: "Debt & Equity",
    appraiser: "Appraiser",
    auditor: "Auditor",
};

export const user_role_type_display_name = {
    ROLE_ACCOUNTING: "Accounting",
    ROLE_ADMIN: "Admin",
    ROLE_ARIZONA_BROKER_ADMIN: "Arizona Broker Admin",
    ROLE_APPRAISER: "Appraiser",
    ROLE_BROKER: "Broker",
    ROLE_PROPERTY_DATA_ENTRY: "CDT",
    ROLE_DEBT_EQUITY: "Debt & Equity",
    ROLE_GENERAL_USER: "General User",
    ROLE_OFFICE_MANAGER: "Office Manager",
    ROLE_PORTLAND_ADMIN: "Portland Broker Admin",
    ROLE_PROPERTY_MANAGEMENT: "Asset Services",
    ROLE_RESEARCH_ADMIN: "Research Admin",
    ROLE_RESEARCH: "Research",
    ROLE_EVP: "RP",
    ROLE_TRANSITION_SPECIALIST: "Transition Specialist",
};

export const all_user_types = [
    "Broker",
    "CDT",
    "Admin",
    "Portland Broker Admin",
    "Accounting",
    "Asset Services",
    "RP",
    "General User",
    "Officer Manager",
    "Research Admin",
    "Research",
    "Transition Specialist",
    "Debt & Equity",
    "Arizona Broker Admin",
    "Office Manager",
    "Appraiser",
    "Auditor",
];

export const notificationModalInfo = [
    {
        title: "Update: New Map Feature with Mapbox",
        description:
            "We're moving from Google Maps to Mapbox\nfor a faster, more powerful mapping experience. See the next\nslides for a quick tour of what's new.",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1831_mapbox_feature/Headliner.mp4",
        interval: 6000,
    },
    {
        title: "Radial Search",
        description: "Select a point and set a distance to create a radial search",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1831_mapbox_feature/Radial_Search.mp4",
        interval: 9000,
    },
    {
        title: "Quickly Switch to Immersive Street View",
        description:
            "Hold CTRL while dragging to rotate the map into street view \nUse the mouse scroll wheel to zoom in and out \n Release CTRL to resume normal panning",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1831_mapbox_feature/Immersive_Street_View.mp4",
        interval: 15000,
    },
    {
        title: "Bug Fix: Clear Polygon Filters",
        description:
            "Click the Polygon filter button to draw a polygon\nDouble-Click to complete the polygon\nClear the polygon filter by removing the search crumb,\nclicking the 'Clear' button, or the trash icon on the map!",
        src: "https://s3.us-east-2.amazonaws.com/connect.kidder.com/content/feature-notifications/WD-1831_mapbox_feature/Polygon_Clearing.mp4",
        interval: 0,
    },
];
